<template>
  <div class="tariffication_packet_items">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
      <div class="select">
        <label> {{ translate('traffic_packet_list.tariffication_packet_item.client_name') }} </label>
        <tree-select
            :options="client_list"
            :multiple="false"
            v-model="filter.client_id"
            :placeholder="translate('traffic_packet_list.tariffication_packet_item.client_name')"
            :clearable="false"
            :searchable="true"
        />
      </div>

      <div class="filter checkbox">
        <div class="info">
          {{ translate('traffic_packet_list.tariffication_packet_item.active') }}
        </div>
        <label class="switch" @click.prevent="filter.active = !filter.active">
          <input type="checkbox" v-model="filter.active">
          <span class="slider round"></span>
        </label>
      </div>
    </div>

    <div class="response_table">
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
        <tr>
          <th scope="col">
            {{ translate('traffic_packet_list.mno_packet_item.date') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.mno_packet_item.fid') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.tariffication_packet_item.client_name') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.tariffication_packet_item.mno_packet_name') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.tariffication_packet_item.tariff_packet_name') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.mno_packet_item.iccid') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.tariffication_packet_item.traffic_type') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.tariffication_packet_item.packet_traffic_available') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.tariffication_packet_item.operator_traffic_available') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.tariffication_packet_item.traffic_used') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.tariffication_packet_item.ts_create') }}
          </th>
          <th scope="col">
            {{ translate('traffic_packet_list.tariffication_packet_item.ts_update') }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
            v-for="(item, key) in items"
            :key="key" class="packet_item"
            @click="show_info(item.id)"
            :class="{ active_item: item.status > 0 }"
        >
          <td :data-label="translate('traffic_packet_list.mno_packet_item.date')">
            {{ item.date }}
          </td>
          <td :data-label="translate('traffic_packet_list.mno_packet_item.fid')">
            <router-link :to="{ path: '/device/' + item.device_fid + '/tariffication' }">
              {{ item.device_fid + '/' + item.device_name }}
            </router-link>
          </td>
          <td :data-label="translate('traffic_packet_list.tariffication_packet_item.client_name')">
            {{ item.client_name }}
          </td>
          <td :data-label="translate('traffic_packet_list.tariffication_packet_item.mno_packet_name')">
            <router-link :to="{ path: '/tariffication/mno_base_packets/' + item.mno_packet_item_id }">
              {{ item.mno_packet_name }}
            </router-link>
          </td>
          <td :data-label="translate('traffic_packet_list.tariffication_packet_item.tariff_packet_name')">
            <router-link
                :to="{ path: '/tariffication/tariff_base_packets/' + item.tariff_packet_item_id }">
              {{ item.tariff_packet_name }}
            </router-link>
          </td>
          <td :data-label="translate('traffic_packet_list.mno_packet_item.iccid')">
            <router-link :to="{ path: '/simcard_profile/' + item.imsi + '/profile' }">
              {{ item.iccid }}
            </router-link>
          </td>
          <td :data-label="translate('traffic_packet_list.tariffication_packet_item.traffic_type')">
            {{ get_traffic_type(item.traffic_type) }}
          </td>
          <td :data-label="translate('traffic_packet_list.tariffication_packet_item.packet_traffic_available')">
            {{ item.packet_traffic_available }}
          </td>
          <td
              :data-label="translate('traffic_packet_list.tariffication_packet_item.operator_traffic_available')">
            {{ item.operator_traffic_available }}
          </td>
          <td :data-label="translate('traffic_packet_list.tariffication_packet_item.traffic_used')">
            {{ item.traffic_used }}
          </td>
          <td :data-label="translate('traffic_packet_list.tariffication_packet_item.ts_create')">
            {{ get_date(item.ts_create) }}
          </td>
          <td :data-label="translate('traffic_packet_list.tariffication_packet_item.ts_update')">
            {{ get_date(item.ts_update) }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import TarifficationPacketItemsModal from "./TarifficationPacketItemsModal/Index.vue";

export default {
  name: 'TarifficationPacketItems',
  components: {
    TarifficationPacketItemsModal
  },
  props: {
    request: {
      type: String,
      default: 'all'
    }
  },

  data() {
    return {
      load: true,
      items: {},
      filter: {
        client_id: null,
        active: true,
      },
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    }
  },

  computed: {
    client_list() {
      let list = [{id: null, label: "All clients"}];
      for (let client of this.$store.getters.getClientsList) {
        list.push({id: client.id, label: client.name});
      }
      return list;
    },
    send_filter() {
      let filter = {...this.filter};
      if (this.filter.client_id === "") {
        delete filter.client_id;
      }
      if (!this.filter.active) {
        delete filter.active;
      }
      return filter;
    },
  },


  created() {
    this.get_packet_items()
    /*this.filter = Object.assign(this.filter, this.tariff_filter);

    if (Object.keys(this.$route.query).length > 0) {
        this.filter.client_id = this.$route.query.client_id;
    }

    this.check_tariff();*/
  },

  activated() {
    if (Object.keys(this.$route.query).length > 0) {
      this.filter.client_id = this.$route.query.client_id;
    }
    this.get_packet_items()
  },

  destroyed() {
    this.$modal.hide("tariff_modal");
  },

  watch: {
    filter: {
      deep: true,
      handler() {
        this.get_packet_items()
      },
    },
  },

  methods: {
    get_traffic_type(traffic_type) {
      if (traffic_type === 2) {
        return "Служебный"
      }
      return "Пользовательский"
    },
    get_packet_items() {
      let params = this.filter
      this.$http.v1.getTarifficationPacketItems(params, (response) => {
        this.items = response.data
      })
    },
    show_info(tariffication_packet_item_id) {
      if (!tariffication_packet_item_id) return
      let t = this.$createElement(TarifficationPacketItemsModal, {
        props: {
          tariffication_packet_item_id
        },
        on: {
          close: () => {
            this.$modal.hide('tariffication_packet_item')
            this.check_link = true
          },
          update: () => {
            this.$emit("update", this.send_filter)
          }
        }
      })
      let temp = {
        render() {
          return t
        }
      }
      this.$modal.show(temp, {}, {
        height: 'auto',
        width: 800, //TODO in const to
        adaptive: true,
        clickToClose: true,
        name: 'tariffication_packet_item'
      })
    },
    toggleFiltersState() {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
  },

}
</script>
<style lang='scss' scoped>
  .tariffication_packet_items {
    height: 100%;
    padding-top: 30px;
    display: flex;
    flex-direction: column;
  }

  table {
    .active_item {
      background-color: #41b88330;
    }
  }

  .header {
    display: flex;
    align-content: center;
    justify-content: space-between;
    flex: 1;

    .select {
      width: 20%;
    }

    .checkbox {
      width: 20%;
      margin: 0;
    }

    .button {
      display: flex;
      align-content: center;
      justify-content: center;
      flex-direction: column;

      .btn {
        padding: 0 5px;
        margin-bottom: 5px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .response_table {
    padding-left: 0;
    padding-right: 0;
    flex: 10;
  }
</style>
